<template>
    <div 
        class="separator" 
        :class="{
            'comfortable': comfortable,
            'dense': !comfortable
        }">
    </div>
</template>

<script>
export default {
    name: 'Separator',
    props: {
        comfortable: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.separator {
    display: block;
    width: 100%;
}

.separator.comfortable {
    height: 15px;
}

.separator.dense {
    height: 5px;
}

@media (max-width: 600px) {
    .separator {
        height: 100%;
    }
    
    .separator.comfortable {
        width: 15px;
    }
    .separator.dense {
        width: 5px;
    }
}
</style>